import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import { SEOService } from 'src/app/services/seo-service/seo.service';

@Component({
  selector: 'app-pmain',
  templateUrl: './page-home.component.html',
  styleUrls: ['./page-home.component.scss']
})
export class PageHomeComponent implements OnInit {

  constructor(private router: Router, private activatedRoute: ActivatedRoute,private seoService: SEOService)  { 
    // this.seoService.addMetaTags();

  }   

  ngOnInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd))
      .subscribe((event) => {
      });
  }

}
